import { Typography } from '@mui/material';
import { ColDef } from 'ag-grid-community';
import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { otherInvestmentsStateJ } from '../../../services/state/CapTableFormStateJ';
import { companyStateJ } from '../../../services/state/CompanyStateJ';
import { selectedCompanyIdProfileAtom } from '../state/UIStateJ';
import { IOtherInvestmentsGridRow, useOtherInvestmentsRowData } from './InvestmentGridDefs';
import { useOtherInvestmentsColDefs } from './OtherInvestmentsDefs';
import { AddInvestmentsGrid } from './AddInvestmentsGrid';

const OtherInvestmentsHelperText = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const company = useAtomValue(companyStateJ(companyId));
  return (
    <Typography variant='subtitle1'>
      {`Please add other investments and options for ${company?.name}.`}
    </Typography>
  );
};

export function AddOtherInvestments() {
  const setOtherInvestments = useSetAtom(otherInvestmentsStateJ);
  const getColDefs = useOtherInvestmentsColDefs();
  const colDefs = useMemo(() => getColDefs(), [getColDefs]);
  const { getInitialRowData } = useOtherInvestmentsRowData();
  const initialRowData = useMemo(() => getInitialRowData(), [getInitialRowData]);

  const setStateToRows = useCallback(
    (rows: IOtherInvestmentsGridRow[]) => {
      setOtherInvestments(rows);
    },
    [setOtherInvestments]
  );

  return (
    <AddInvestmentsGrid
      initialRowData={initialRowData}
      colDefs={colDefs as ColDef<IOtherInvestmentsGridRow>[]}
      setStateToRows={setStateToRows}
      HelpInfo={OtherInvestmentsHelperText}
    />
  );
}
